// removed by extract-text-webpack-plugin
module.exports = {"inputRow":"src-components-ExternalInvest-components-___InputRow__inputRow___3c-MB","label":"src-components-ExternalInvest-components-___InputRow__label___1HWWP","inputBox":"src-components-ExternalInvest-components-___InputRow__inputBox___201vv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalInvest/components/InputRow.css
// module id = 1246
// module chunks = 3